module.exports = __webpack_public_path__ + "b861fa8c39704f6701e2e23c4f2fdbc2.png";